import apiClient from "../lib/apiClient";

//=========Login=============
export const loginUser = async (data) => {
  try {
    const response = await apiClient.post("/Users/DBLogin", data);

    const resData = response.data;

    if (resData?.isSuccess) {
      return {
        success: true,
        message: resData?.displayMessage || "Login successful",
        data: resData,
      };
    }

    return {
      success: false,
      message: resData?.errorMessages?.[0] || resData?.displayMessage || "Login failed",
      data: null,
    };
  } catch (error) {
    return {
      success: false,
      message: error?.response?.data?.displayMessage || error?.response?.data?.errorMessages?.[0] || error.message || "Something went wrong",
      data: null,
    };
  }
};

//============SignUp api===========
export const signupUser = (data) => {
  return apiClient.post("/Users/RegisterUser", data);
};

//===========Get Login user Details==================

  // export const getStudentDetails = async () => {
  //   const user = JSON.parse(localStorage.getItem("user") || "null");

  //   const res = await apiClient.post("/User/GetStudentDetailsByID", {
  //     ID: -1,
  //     UserID: user?.userID
  //   });

  //   return res.data;
  // };

export const getStudentDetails = async () => {

  const storedUser = localStorage.getItem("user");

  const user = storedUser
    ? JSON.parse(storedUser)
    : null;

  const payload = {
    ID: -1,
    UserID: user?.userID,
  };

  console.log("Payload Check:", payload);

  return apiClient.post(
    "/User/GetStudentDetailsByID",
    payload
  );
};

export const loginWithOtp = async (data) => {
  try {
    const response = await apiClient.post("/Users/LoginWithOtp", data);

    const resData = response.data;

    if (resData?.isSuccess) {
      return {
        success: true,
        message: resData?.displayMessage || "Login successful",
        data: resData,
      };
    }

    return {
      success: false,
      message: resData?.errorMessages?.[0] || resData?.displayMessage || "Login failed",
      data: null,
    };
  } catch (error) {
    return {
      success: false,
      message: error?.response?.data?.displayMessage || error?.response?.data?.errorMessages?.[0] || error.message || "Something went wrong",
      data: null,
    };
  }
};